// extracted by mini-css-extract-plugin
module.exports =  {"banks-list":"ccfda6eb9f--banks-list--v4yho","bank":"ccfda6eb9f--bank--WbN71","bank-icon":"ccfda6eb9f--bank-icon--L8Cn0"};